// Components
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Icon from '@mui/material/Icon'

// Assets
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined'
import {
  faListOl,
  faListUl,
  faChartColumn,
  faClockRotateLeft,
  faCartShopping,
} from '@fortawesome/free-solid-svg-icons'
import { PiChalkboardTeacherDuotone } from 'react-icons/pi'
import { LuCopyPlus } from 'react-icons/lu'
import { HiMiniSquaresPlus } from 'react-icons/hi2'
import { TfiEmail } from 'react-icons/tfi'
import { MdOutlineReportProblem } from 'react-icons/md'
import { IoMdGift } from 'react-icons/io'
import { CgProfile } from 'react-icons/cg'

export const routeTypes = {
  basicRoute: 'route',
  basicDivider: 'divider',
  basicTitle: 'title',
  hidden: 'hidden',
  adminTitle: 'admin-title',
  adminDivider: 'admin-divider',
  adminRoute: 'admin-route',
  teacherTitle: 'teacher-title',
  teacherDivider: 'teacher-divider',
  teacherRoute: 'teacher-route',
}

import pages from 'constants/pages'

const {
  basicRoute,
  basicDivider,
  basicTitle,
  hidden,
  adminTitle,
  adminDivider,
  adminRoute,
  teacherTitle,
  teacherDivider,
  teacherRoute,
} = routeTypes

const routes = [
  {
    type: basicTitle,
    title: 'Rezolvă',
  },
  {
    type: basicRoute,
    name: 'Grile',
    key: 'grile',
    icon: (
      <Icon fontSize="small" className="h-full w-full">
        checkbox
      </Icon>
    ),
    route: pages.app.grid,
  },
  {
    type: basicRoute,
    name: 'Simulare',
    id: 'subject-nav-button',
    key: 'subiect',
    icon: <FontAwesomeIcon icon={faListUl} />,
    route: pages.app.subject,
  },
  {
    type: basicDivider,
  },
  {
    type: basicTitle,
    title: 'Statistici',
  },
  {
    type: basicRoute,
    name: 'Statistici',
    id: 'dashboard-nav-button',
    key: 'dashboard',
    icon: <FontAwesomeIcon icon={faChartColumn} />,
    route: pages.app.dashboard,
  },
  {
    type:
      process.env.REACT_APP_DISABLE_CLASAMENT === 'true' ? hidden : basicRoute,
    name: 'Clasament',
    key: 'clasament',
    icon: <FontAwesomeIcon icon={faListOl} />,
    route: pages.app.ranking,
  },
  {
    type: basicRoute,
    name: 'Istoric',
    id: 'history-nav-button',
    key: 'istoric',
    icon: <FontAwesomeIcon icon={faClockRotateLeft} />,
    route: pages.app.history,
  },
  {
    type: basicDivider,
  },
  {
    type: basicTitle,
    title: 'Cont',
  },
  {
    type: basicRoute,
    name: 'Abonamente',
    key: 'payment',
    icon: <FontAwesomeIcon icon={faCartShopping} />,
    route: pages.app.payment,
  },
  {
    type: basicRoute,
    id: 'profile-nav-button',
    name: 'Profil',
    key: 'profile',
    icon: <CgProfile fontSize={20} />,
    route: pages.app.profile,
  },
  {
    type: basicDivider,
  },
  {
    type: basicTitle,
    title: 'Suport',
  },
  {
    type: basicRoute,
    name: 'Contact / Feedback',
    key: 'feedback',
    icon: <FeedbackOutlinedIcon className="!w-[20px] !h-[20px]" />,
    route: pages.app.contact,
  },
  {
    type: teacherDivider,
  },
  {
    type: teacherTitle,
    title: 'Profesori',
  },
  {
    type: teacherRoute,
    name: 'Lista Studenti',
    key: 'teacher',
    icon: (
      <PiChalkboardTeacherDuotone fontSize="22px">
        teacher
      </PiChalkboardTeacherDuotone>
    ),
    route: pages.app.teacher,
  },
  {
    type: teacherRoute,
    name: 'Creează Test',
    key: 'create-subject',
    icon: <HiMiniSquaresPlus fontSize="22px" />,
    route: pages.app.createSubject,
  },
  {
    type: teacherRoute,
    name: 'Creează Grilă',
    key: 'create-grid',
    icon: <LuCopyPlus fontSize="22px" />,
    route: pages.app.createGrid,
  },
  {
    type: adminDivider,
  },
  {
    type: adminTitle,
    title: 'Admin',
  },
  {
    type: adminRoute,
    name: 'Creează Mail',
    key: 'create-mail',
    icon: <TfiEmail fontSize="22px" />,
    route: pages.app.createMail,
  },
  {
    type: adminRoute,
    name: 'Creează Voucher',
    key: 'create-voucher',
    icon: <IoMdGift fontSize="22px" />,
    route: pages.app.createVoucher,
  },
  {
    type: adminRoute,
    name: 'Raportate',
    key: 'reports',
    icon: <MdOutlineReportProblem fontSize="22px" />,
    route: pages.app.reports,
  },
]

export default routes
